import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {Store} from '@ngrx/store';
import {HolidayState} from '../../store/holiday/holiday.reducer';
import * as HolidayActions from '../../store/holiday/holiday.actions';
import { MatDialog } from '@angular/material/dialog';
import {HolidayComponent} from '../holiday/holiday.component';
import {ConfirmDialogComponent} from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { selectHolidayState } from '../../store/holiday/holiday.adapter';
import { Observable } from 'rxjs';
import { IHoliday } from '@signal/asp-data-commons';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionList } from '../../shared/models/asp.types';
import { unsubscribeSubscriptions } from '../../shared/services/util.service';

@Component({
  selector: 'app-holidays-card',
  templateUrl: './holidays-card.component.html',
  styleUrls: ['./holidays-card.component.scss']
})
export class HolidaysCardComponent implements OnInit, OnDestroy {

  @Input() holiday: IHoliday
  holidayState$: Observable<HolidayState>;
  department:string;
  private subs: SubscriptionList = {};

  constructor(private readonly holidayStore: Store<HolidayState>,
              public readonly dialog: MatDialog,
              private readonly translate: TranslateService) {
    this.holidayState$ = this.holidayStore.select(selectHolidayState)
  }

  ngOnInit() {
    this.subs.holidayState = this.holidayState$.subscribe((obj:HolidayState) => {
      this.department = obj.department;
    })
  }

  deleteHoliday(id) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      height: '220px',
      data: {},
      panelClass: 'asp-modal-container'
    });
    this.subs.dialogRef = dialogRef.afterClosed().subscribe((result) => {
      if (result.action === 'confirm') {
        const obj = {
          department:this.department,
          holidayId:id
        }
        this.holidayStore.dispatch(new HolidayActions.DeleteHoliday(obj));
      }
    })
  }

  updateHoliday(payload) {
    const dialogRef = this.dialog.open(HolidayComponent, {
      width: '400px',
      height: '495px',
      panelClass: 'asp-modal-container',
      disableClose:true,
      data:{payload,clicked:true}
    });
    this.subs.dialogRefSubs = dialogRef.componentInstance.onEdit.subscribe((result) => {
      const obj = {
        department:this.department,
        holiday:result
      }
      this.holidayStore.dispatch(new HolidayActions.UpdateHoliday(obj));
    })

  }
  getMonthTranslation(month){
    return month ? this.translate.instant(`common.${month}`) : month;
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
  }

}
